import axios from 'axios';
// eslint-disable-next-line
import router from '@/router';
// eslint-disable-next-line
import store from '@/store';

const api = axios.create({
	baseURL: process.env.VUE_APP_API_BASE,
	timeout: 5000,
});

api.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response.status === 401) {
			store.dispatch('clearAll')
				.then(() => {
					router.push({ name: 'Login' });
				});
		}
		return Promise.reject(error);
	},
);

api.interceptors.request.use((config) => {
	// eslint-disable-next-line no-console
	if (store.getters['me/isLoggedIn']) {
		// eslint-disable-next-line no-param-reassign
		config.headers.Authorization = `Bearer ${store.state.me.token}`;
	}
	return config;
});

export default api;
